import { ActionType, NetworkActionPrefix } from '../utils/constants';
import { CompanyAccessFunctionalityAddOnApi, CompanyApi, CompanyTemplateTypeApi, UserPartnerAccessApi } from 'for-straction-service-api';
import { entityLifecycleActionSet, networkAPIAction } from '../utils/actionCreatorsFactory';

export const addClientCompany = (clientCompany, templateID, firstUserEmail, usesNetvisor, logoURI) =>
    networkAPIAction(new CompanyApi(), 'companyAddClientCompanyPut', NetworkActionPrefix.ADD_CLIENT_COMPANY_PREFIX, { clientCompany, templateID, firstUserEmail, usesNetvisor, logoURI }, clientCompany, templateID, firstUserEmail, usesNetvisor, logoURI);

export function editCurrentCompany(companyObj) {
    return (dispatch) => {
        dispatch({
            type: ActionType.EDIT_CURRENT_COMPANY,
            currentCompany: companyObj
        });

        dispatch(syncCurrentCompany(companyObj));
    };
}

export function syncCurrentCompany(companyObj) {
    return networkAPIAction(new CompanyApi(), 'companyEditCurrentCompanyPut', NetworkActionPrefix.EDIT_CURRENT_COMPANY_PREFIX, { currentCompany: companyObj }, companyObj);
}

export const loadCurrentCompany = networkAPIAction.bind(this, new CompanyApi(), 'companyLoadCurrentCompanyGet', NetworkActionPrefix.LOAD_CURRENT_COMPANY_PREFIX, {});

export const loadPartnerCompanies = () => networkAPIAction(new CompanyApi(), 'companyLoadPartnerCompaniesGet', NetworkActionPrefix.LOAD_PARTNER_COMPANIES_PREFIX);

export const signPartnerAgreement = (companyID, userName) => networkAPIAction(new CompanyApi(), 'companySignPartnerAgreementGet', NetworkActionPrefix.SIGN_PARTNER_AGREEMENT_PREFIX, { companyID, userName });

export const sendNotificationToContractSignee = () => networkAPIAction(new CompanyApi(), 'companySendNotificationToContractSigneeGet', NetworkActionPrefix.SEND_NOTIFICATION_TO_CONTRACT_SIGNEE_PREFIX);

const companyAccessFunctionalityAddOnActionSet = entityLifecycleActionSet('CompanyAccessFunctionalityAddOn', 'COMPANY_ACCESS_FUNCTIONALITY_ADD_ON', 'companyAccessFunctionalityAddOn', CompanyAccessFunctionalityAddOnApi, {
    add: true,
    loadAll: 'companyAccessFunctionalityAddOnLoadAllForCurrentCompanyGet'
});
export const addCompanyAccessFunctionalityAddOn = (companyAccessFunctionalityAddOn, sync) => companyAccessFunctionalityAddOnActionSet.addCompanyAccessFunctionalityAddOn(companyAccessFunctionalityAddOn, sync);
export const loadAllCompanyAccessFunctionalityAddOns = () => companyAccessFunctionalityAddOnActionSet.loadAllCompanyAccessFunctionalityAddOns();

export const deleteCompanyAccessFunctionalityAddOn = (companyAccessFunctionalityAddOnID, accessFunctionalityAddOnID) =>
    networkAPIAction(CompanyAccessFunctionalityAddOnApi, 'companyAccessFunctionalityAddOnDeleteGet', NetworkActionPrefix.DELETE_COMPANY_ACCESS_FUNCTIONALITY_ADD_ON_PREFIX, { companyAccessFunctionalityAddOnID, accessFunctionalityAddOnID }, companyAccessFunctionalityAddOnID);

export const loadAllCompanyTemplateTypes = () => networkAPIAction(CompanyTemplateTypeApi, 'companyTemplateTypeLoadAllGet', NetworkActionPrefix.LOAD_ALL_COMPANY_TEMPLATE_TYPES_PREFIX);

export const loadUserPartnerAccesses = () => networkAPIAction(new UserPartnerAccessApi(), 'userPartnerAccessLoadPartnerAccessesGet', NetworkActionPrefix.LOAD_USER_PARTNER_ACCESSES_PREFIX, {});
